<template>
    <el-card class="amount-box-card">
        <div class="flexY box-card-content">
            <div class="card-header flexX flexBetween flexcenter">
                <div class="card-title c606266 fs14 fw5">{{title}}</div>
                <div class="card-time flexX">
                    <el-button class="query-btn" :type="amountCardData.date == 'today'?'primary':'info'" size="mini" @click="changeDate('today')">今日</el-button>
                    <el-button class="query-btn" :type="amountCardData.date == 'yesterday'?'primary':'info'" size="mini" @click="changeDate('yesterday')">昨日</el-button>
                    <el-button class="query-btn" :type="amountCardData.date == 'total'?'primary':'info'" size="mini" @click="changeDate('total')">总计</el-button>
                </div>
            </div>
            <div class="amount-card-content c303133 fw7 fs32">
                ¥{{dataObj[amountCardData.date]}}
            </div>
            
        </div>
    </el-card>
</template>
<script> 
export default { 
    name: 'amountCard',
    props:{
        dataObj:{
            type:Object,
            default: function () {
                return {}
            }
        },
        title:{
            type:String,
            default: ''
        }

    },
    data(){
        return { 
            amountCardData:{
                date:"today"
            }
            
        }
    },
    methods:{
        changeDate(date){
            this.amountCardData.date = date
        }
    }
}
</script>
<style lang="scss" >
    .amount-box-card {
        .el-button--info{
            background: #f5f7fa;
            color:#909399;
            border: none;
        }
    }

</style>

<style lang="scss" scoped>
    .amount-box-card {
        height: 140px;
        box-sizing: border-box;
        .box-card-content{
            .card-header{
            margin-bottom: 8px;
            .card-time{
                gap: 4px;
                .query-btn{
                    margin: 0;
                }
            }
        }
        .amount-card-content{

        }
        }
        
    }

</style>